import React from 'react';

export const instagramIcon = ({ ariaLabel = 'Instagram' } = {}) => {
  return (
    <img
      src="/static/images/instagram.png"
      alt={ariaLabel}
      className="w-12 h-12"
      style={{ display: 'inline-block' }}
    />
  );
};
